import React from "react"
import { makeStyles } from "@material-ui/core/styles"

export const workflows: {
  [id: string]: {
    title: string
    caption: string
    steps: string[]
    displayWidth?: number
  }
} = require("../../data/workflows.json")
const useStyles = makeStyles({
  viewport: {
    overflowX: "auto",
    borderRadius: 8,
    background: "#fff",
    padding: "16px 0",
  },
  image: {
    display: "block",
    width: "100%",
    minWidth: 500,
    maxWidth: 560,
    height: "auto",
    margin: "0 auto",
  },
  scrollHint: {
    fontSize: 13,
    color: "#536174",
    margin: "0 0 8px",
    "@media (min-width: 600px)": { display: "none" },
  },
  text: {
    marginTop: 16,
    "& summary": { cursor: "pointer", fontWeight: 600 },
    "& li": { marginTop: 8 },
  },
})

export default function WorkflowDiagram({ id }: { id: string }) {
  const c = useStyles()
  const workflow = workflows[id]
  return (
    <>
      <p className={c.scrollHint}>
        Swipe across the diagram, or read the steps below.
      </p>
      <div
        className={c.viewport}
        tabIndex={0}
        role="region"
        aria-label={`${workflow.title} diagram; scroll horizontally if needed`}
      >
        <img
          className={c.image}
          style={
            workflow.displayWidth
              ? {
                  maxWidth: workflow.displayWidth,
                  minWidth: workflow.displayWidth,
                }
              : undefined
          }
          src={`/diagrams/${id}.svg`}
          alt={`${workflow.title}. A step-by-step text version follows.`}
          loading="lazy"
        />
      </div>
      <details className={c.text}>
        <summary>Read the workflow steps</summary>
        <ol>
          {workflow.steps.map(step => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </details>
    </>
  )
}
